import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { createDevice } from './thunks/createDevice.thunk';
import { deleteDevice } from './thunks/deleteDevice.thunk';
import { loadDevicesBySelectedProjectBusinessId } from './thunks/loadDevicesBySelectedProjectBusinessId.thunk';
import { updateDevice } from './thunks/updateDevice.thunk';

const devicesAdapter = createEntityAdapter();

const devicesSlice = createSlice({
  name: 'devices',
  initialState: {
    devices: devicesAdapter.getInitialState(),
    loading: false,
    devicesLoaded: false,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(
        loadDevicesBySelectedProjectBusinessId.pending,
        (state, action) => {
          state.loading = true;
        }
      )
      .addCase(
        loadDevicesBySelectedProjectBusinessId.fulfilled,
        (state, action) => {
          devicesAdapter.setMany(state.devices, action.payload);
          state.devicesLoaded = true;
          state.loading = false;
        }
      )
      .addCase(
        loadDevicesBySelectedProjectBusinessId.rejected,
        (state, action) => {
          state.loading = false;
        }
      )
      .addCase(createDevice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createDevice.fulfilled, (state, action) => {
        devicesAdapter.setOne(state.devices, action.payload);
        state.loading = false;
      })
      .addCase(createDevice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDevice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateDevice.fulfilled, (state, action) => {
        devicesAdapter.setOne(state.devices, action.payload);
        state.loading = false;
      })
      .addCase(updateDevice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteDevice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteDevice.fulfilled, (state, action) => {
        devicesAdapter.removeOne(state.devices, action.payload);
        state.loading = false;
      })
      .addCase(deleteDevice.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default devicesSlice.reducer;
